<template>
    <div>
        <div class="normalheader ">
            <div class="hpanel">
                <div class="panel-body">
                    <div id="hbreadcrumb" class="pull-right m-t-lg">
                        <ol class="hbreadcrumb breadcrumb">
                            <li>
                                <router-link tag="a" :to="{name:'dashboard'}">Portadaw</router-link>
                            </li>
                            <li>
                                <span>Usuarios APP Admin</span>
                            </li>
                            <li class="active">
                                <span>Lista de usuarios</span>
                            </li>
                        </ol>
                    </div>
                    <h2 class="font-light m-b-xs">
                        Lista de usuarios
                    </h2>
                    <small>Gestionar usuarios</small>
                </div>
            </div>

        </div>
        <div class="content">
            <div class="hpanel hviolet">
                <div class="panel-heading hbuilt">
                    Usuarios APP Admin
                </div>
                <div class="panel-body">
                    <div class="m-b-md">
                        <div class="m-b-sm">
                            <button class="btn btn-default" type="button" data-toggle="collapse"
                                    data-target="#userListFilters" aria-expanded="false" @click="toggleFilter"
                                    aria-controls="userListFilters">
                                Filtros
                                <i :class="'fa fa-caret-' + (filterFlag ? 'down' : 'up')"></i>
                            </button>
                            <router-link class="btn btn-primary btn-outline pull-right" tag="button" :to="userNewRoute">
                                Crear
                                <i class="fa fa-plus"></i></router-link>
                        </div>
                        <div class="collapse" id="userListFilters">
                            <div class="form">
                                <div class="row">
                                    <div class="col-md-3 form-group">
                                        <label>Usuario</label>
                                        <custom-input tipo="text" :field="$v.filters.username"/>
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label>Estado</label>
                                        <custom-input tipo="select" :field="$v.filters.status" :items="statuses"/>
                                    </div>
                                </div>
                                <div class="row text-center">
                                    <div class="col-md-12">
                                        <button type="button" class="btn btn-default" @click="clear">
                                            Limpiar filtros
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                        <button type="button" class="btn btn-primary" @click="search">
                                            Aplicar filtros
                                            <i class="fa fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="table-responsive">
                        <table cellpadding="1" cellspacing="1" class="table table-bordered table-striped">
                            <thead>
                            <tr>
                                <th>Usuario</th>
                                <th>Estado</th>
                                <th style="width:6%">Acciones</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="o in data" :key="o.id">
                                <td><span>{{ o.username }}</span></td>
                                <td align="center">
                                    <status-badge :status="o.status"/>
                                </td>
                                <td align="center" class="action-cell">
                                    <div class="dropdown">
                                        <a type="button" class="dropdown-toggle" data-toggle="dropdown"><i
                                            class="fa fa-gear"></i></a>
                                        <ul class="dropdown-menu filedropdown m-l pull-right">
                                            <li><a @click="goToEdit(o.id)">EDITAR</a></li>
                                            <li><a @click="toggleUserState(o.id, o.status)">{{
                                                    o.status === 1 ?
                                                        'INACTIVAR' : 'ACTIVAR'
                                                }}</a></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <paginator :total-elements="totalElements" :page-number="pageNumber" :total-pages="totalPages"
                               :change-page="changePage"/>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import {APP_ADMIN_USER_EDIT, APP_ADMIN_USER_LIST, APP_ADMIN_USER_NEW} from "../../router/routes";
import CustomInput from '../common/CustomInput.vue'
import StatusBadge from '../common/StatusBadge.vue'
import AppAdminUserService from '../../services/AppAdminUserService';
import {maxLength} from 'vuelidate/lib/validators'
import {profileList, appAdminUserStatusList} from '../../util/selectOptions'
import {paginationMixin} from '../../util/paginationMixin'
import {filterMixin} from '../../util/filterMixin'
import Alert from "../../util/alert";


export default {
    name: APP_ADMIN_USER_LIST.name,
    mixins: [
        paginationMixin,
        filterMixin
    ],
    components: {CustomInput, StatusBadge},
    data: () => ({
        userNewRoute: APP_ADMIN_USER_NEW.route,
        data: [],
        statuses: appAdminUserStatusList,
        profiles: profileList,
        filters: {
            username: null,
            status: null,
        }
    }),
    validations: {
        filters: {
            username: {maxLength: maxLength(100)},
            status: {},
        }
    },
    methods: {
        async init() {
            const self = this;

            let activeState = {
                key: 1,
                value: "ACTIVO"
            };

            self.filters.status = activeState
            await self.getData({ status: activeState.key })
        },
        search() {
            this.$v.$touch();
            if (this.$v.$error) return;
            const self = this;

            const data = {
                ...self.filters, ...{
                    status: self.filters.status ? self.filters.status.key : null,
                }
            };
            self.getData(data)
        },
        clear() {
            this.filters.username = this.filters.status = null;
            this.$v.$reset();
        },
        goToEdit(userId) {
            this.$router.push({path: APP_ADMIN_USER_EDIT.route.replace(":userId", userId)})
        },
        onToggleState(user) {
            const users = this.data.filter((o) => {
                return o.id === user.id;
            });
            const userFiltered = users && users.length > 0 ? users[0] : null;
            const index = this.data.indexOf(userFiltered);
            this.$set(this.data, index, user);
        },
        async toggleUserState(userId, source) {
            try {
                const status = source === 1 ? 2 : 1;
                const userUpdated = (await AppAdminUserService.toggleUserState(userId, status)).data.payload;
                this.onToggleState(userUpdated);
            } catch (err) {
                Alert.mensajeError(err.message);
            }
        },
        async getData(params = {}, page = 1) {
            params.page = page - 1;
            params.size = this.pageSize;
            this.params = params;
            this.loading = true;
            const payload = (await AppAdminUserService.filterUsers(params)).data.payload;
            this.data = payload.content;
            this.totalPages = payload.totalPages;
            this.totalElements = payload.totalElements;
            this.pageNumber = payload.number + 1;
            this.loading = false;
        },
    },
    async mounted() {
        this.init();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/appadminuser/AppAdminUserList.vue